import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useAsyncError, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form, Dropdown } from "react-bootstrap";
import {
  subCategoryGet,
  subcatHideShowAxios,
} from "../../Actions/axios";
import { toast } from "react-toastify";

const SubCategoryList = () => {
  const navigate = useNavigate();
  const [subcatList, setsubCatList] = useState([]);

  const getSubcategoryGet = async () => {
    let resp = await subCategoryGet();
    console.log("🚀 ~ getSubcategoryGet ~ resp:", resp)
    if (resp?.status) {
      setsubCatList(resp?.data);
    }
  };

  const subcategoryhideshow = async (id) => {
    let resp = await subcatHideShowAxios({ _id: id });
    console.log("🚀 ~ subcategoryhideshow ~ resp:", resp)
    if (resp?.status) {
      toast.success(resp?.message);
      getSubcategoryGet();
    }
  };

  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{i + 1}</p>,
    },
    {
      name: "Name",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{row?.name}</p>,
    },
    {
      name: "Category Name",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{row?.catId?.name}</p>,
    },
    {
      name: "isVisible",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <>
            <button
              type="button"
              className="btn sitebtn"
              onClick={() => subcategoryhideshow(row?._id)}
            >
              {row?.isVisible ? "HIDE" : "SHOW"}
            </button>
          </>
        );
      },
    },
    {
      name: "Edit",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${row._id}`}
              onClick={() =>
                navigate("/editsubcategory", {
                  state: {
                    ...row,
                  },
                })
              }
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];

  useEffect(() => {
    getSubcategoryGet();
  }, []);
  return (
    <div className="cmslist">
      <h1 className="pagehead">SubCategory List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/addsubcategory" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={subcatList}
            pagination
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default SubCategoryList;
